export interface IImageDimensions {
	height: number;
	width: number;
}

const isMeasured = (source: IImageDimensions | undefined): source is IImageDimensions =>
	!!source && source.width > 0 && source.height > 0;

export type CropPresetKey = 'original' | 'square' | 'portrait' | 'landscape' | 'wide' | 'tall';

export interface ICropPreset {
	key: CropPresetKey;
	label: string;
	/** Width over height. Unset only for 'original', until the source has been measured. */
	ratio?: number;
}

// No free-form shape: react-easy-crop's box cannot be resized, and an unset aspect only falls back to 4:3.
const CROP_PRESETS: readonly ICropPreset[] = [
	{ key: 'square', label: 'Square', ratio: 1 },
	{ key: 'portrait', label: 'Portrait', ratio: 4 / 5 },
	{ key: 'landscape', label: 'Landscape', ratio: 1.91 },
	{ key: 'wide', label: 'Wide', ratio: 16 / 9 },
	{ key: 'tall', label: 'Tall', ratio: 9 / 16 },
] as const;

export const buildPresets = (source: IImageDimensions | undefined): ICropPreset[] => {
	const original: ICropPreset = {
		key: 'original',
		label: 'Original',
		ratio: isMeasured(source) ? source.width / source.height : undefined,
	};
	return [original, ...CROP_PRESETS];
};
